import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '@sdb-develop/learning-composition-player/src/store/store.js';
import { applyStyles } from '@sdb-develop/learning-composition-player/src/helpers/stylesheets.js';
import { colors } from '@sdb-develop/learning-frontend/dist/src/sdb-colors.js';
import '@sdb-develop/learning-frontend';
import '@sdb-develop/learning-composition-player/src/components/shared/sdb-spinner.js';
import '@sdb-develop/learning-composition-player/src/components/player/sdb-embedded-composition-player-header.js';
import '@sdb-develop/learning-composition-player/src/components/player/sdb-embedded-composition-player.js';
import '@sdb-develop/learning-composition-player/src/components/buttons/sdb-embedded-composition-reset-button.js';
import '@sdb-develop/learning-composition-player/src/components/composition/sdb-embedded-composition-user-state.js';
import '@sdb-develop/learning-composition-player/src/components/elearning/sdb-embedded-elearning-dialog.js';

@customElement('sdb-player-demo-app')
class SdbPlayerDemoApp extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor targetId;

    @property({ type: String })
    accessor catalogName;

    @property({ type: String })
    accessor sessionId;

    @property({ type: String })
    accessor type;

    @property({ type: Boolean })
    accessor preview;

    @property({ type: Boolean })
    accessor hideCompositionStatus = false;

    @property({ type: Boolean })
    accessor hideHeaderButtons = false;

    @property({ type: String })
    accessor idString;

    @state()
    accessor compositionTitle = '';

    @state()
    accessor singleItem = true;

    @state()
    accessor mainViewEnabled = false;

    @state()
    accessor resetAllLoading = false;

    get demoIdStrings() {
        return [this.user.profile.idString];
    }

    stateChanged(state) {
        this.userName = state.oidc.user.profile.name;
        this.user = state.oidc.user;
        this.compositionTitle = state.composition.data?.title;
    }

    static get styles() {
        return css`

            .sdb-header {
                background: #fff;
                height: 70px;
                border-bottom: 1px solid #ddd;
                padding-left: 10%;
                padding-right: 10%;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .title {
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: start;
            }

            .chip {
                background: orange;
                padding: 3px 15px 5px 15px;
                margin-left: 20px;
                border-radius: 8px;
                font-size: 16px;
                color: #fff;
                position: relative;
                top: -2px;
            }

            .buttons {
                margin-top: 20px;
                margin-left: 50px;
                margin-right: 50px;
            }

            .hero {
                margin-top: 20px;
                margin-left: 50px;
                margin-right: 50px;
                background: #1E968B;
            }

            .content-card {
                width: 30%;
                border: 1px solid #888;
                margin-left: 50px;
                padding: 20px;
            }

            .button-bar {
                background: #eee;
                height: 70px;
                border-bottom: 1px solid #ddd;
                padding-left: 10%;
                padding-right: 10%;
                display: flex;
                align-items: center;
            }
        `;
    }

    connectedCallback() {
        super.connectedCallback();
        document.title = 'SDB Composition Player Demo';
    }

    render() {
        if (this.error)
            return html`
                <style>
                    div {
                        margin: 20px;
                    }
                </style>
                <div>${this.error}</div>
            `;

        if (this.isLoading)
            return html`<div class="spinner"></div>`;

        return html`
            <div class="sdb-header">
                <div class="title">
                    <div>${this.compositionTitle}</div>
                    <div><span class="chip">DEMO</span></div>
                </div>
                <div>${this.userName}</div>
            </div>
            <div class="buttons">
                <sdb-embedded-composition-reset-button
                    .settings=${{ portalIdentifier: 'TCG', env: window.ENVIRONMENT }}
                    .user=${this.user}
                    targetId=${this.targetId}
                    compositionName=${this.compositionTitle}
                    .idString=${this.user.profile.idString}
                    @reset=${(e) => this._onResetAdmin(e)}>
                </sdb-embedded-composition-reset-button>
                <sdb-embedded-composition-reset-button
                    .settings=${{ portalIdentifier: 'TCG', env: window.ENVIRONMENT }}
                    .user=${this.user}
                    targetId=${this.targetId}
                    compositionName=${this.compositionTitle}
                    .idStrings=${this.demoIdStrings}
                    @resetAllStart=${(e) => this.resetAllLoading = true}
                    @resetAllCompleted=${(e) => this.resetAllLoading = false}>
                </sdb-embedded-composition-reset-button>
            </div>
            <div class="content-card" style="width:840px;">
                <sdb-embedded-composition-user-state
                    .settings=${{ portalIdentifier: 'TCG', env: window.ENVIRONMENT }}
                    .user=${this.user}
                    targetId=${this.targetId}
                    .idString=${this.user.profile.idString}
                    small
                    compressed>
                </sdb-embedded-composition-user-state>
            </div>
            <div class="hero">
                <sdb-embedded-composition-player-header
                    .settings=${{ portalIdentifier: 'TCG', env: window.ENVIRONMENT }}
                    .user=${this.user}
                    catalogName=${this.catalogName}
                    targetId=${this.targetId}
                    @start=${(e) => this._onStart(e)}
                    @reset=${(e) => this._onReset(e)}
                    ?preview=${this.preview}
                    light>
                </sdb-embedded-composition-player-header>
            </div>
            <div class="content-card" style="width:840px;">
                <sdb-embedded-composition-player-header
                    .settings=${{ portalIdentifier: 'TCG', env: window.ENVIRONMENT }}
                    .user=${this.user}
                    catalogName=${this.catalogName}
                    targetId=${this.targetId}
                    @start=${(e) => this._onStart(e)}
                    ?hideHeaderButtons=${this.hideHeaderButtons}
                    @reset=${(e) => this._onReset(e)}
                    ?preview=${this.preview}
                    small
                    compressed>
                </sdb-embedded-composition-player-header>
            </div>
            <sdb-layout-main>
                ${this.mainViewEnabled ? html`
                    <sdb-embedded-composition-player
                        .settings=${{ portalIdentifier: 'TCG', env: window.ENVIRONMENT }}
                        .user=${this.user}
                        targetId=${this.targetId}
                        sessionId=${this.sessionId}
                        .type=${this.type}
                        ?hideCompositionStatus=${this.hideCompositionStatus}
                        ?preview=${this.preview}>
                    </sdb-embedded-composition-player>
                ` : nothing}
            </sdb-layout-main>

            ${this.resetAllLoading ? html`<sdb-spinner></sdb-spinner>` : nothing}

            <sdb-embedded-elearning-dialog
                .settings=${{ portalIdentifier: 'TCG', env: window.ENVIRONMENT }}
                .user=${this.user}>
            </sdb-embedded-elearning-dialog>
        `;
    }

    firstUpdated() {
        applyStyles(colors, true);
    }

    _onStart(e) {
        this.mainViewEnabled = !e.detail.isSingleItem;
    }

    _onReset(e) {
        this.mainViewEnabled = !e.detail.isSingleItem;
    }

    _onResetAdmin() {
        location.reload();
    }
}
